module.exports = __webpack_public_path__ + "img/main-gallery5.8a16cbc5.jpg";